import {styled} from '@esgi/ui/theme';

export const InputHidden = styled('input', {
	display: 'none',

	'&[hidden]': {
		display: 'none',
	},
});
